import React from 'react';
import { tv } from 'tailwind-variants';
import { statusVariants, type StatusAppearances, type StatusIntents } from '~/theme/variants';

const chipStyles = tv({
	extend: statusVariants,
	base: 'rounded-md px-2 py-0.5 text-xs font-semibold',
	defaultVariants: {
		intent: 'neutral',
		appearance: 'outline'
	}
});

export interface ChipProps {
	intent?: StatusIntents;
	appearance?: StatusAppearances;
	label: string;
	className?: string;
}

export function Chip({ intent, appearance, label, className }: ChipProps) {
	return <span className={chipStyles({ intent, appearance, className })}>{label}</span>;
}
